import { AnrokIntegrationConfiguration } from '@vy/integrations-types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { AnrokConfigurationFormValues } from '../AnrokConfigurationFormSchema';

export function getAnrokIntegrationSettings(configuration: AnrokConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.anrok,
    integrationConfiguration: mapFormValuesToAnrokSettings(configuration),
  };
}

function mapFormValuesToAnrokSettings(
  formValues: AnrokConfigurationFormValues,
): DeepPartial<AnrokIntegrationConfiguration> {
  return {
    authConfig: {
      apiKey: formValues.apiKey,
    },
    generalConfig: {
      defaultExternalProductId: formValues.defaultExternalProductId,
      defaultTaxMethod: formValues.defaultTaxMethod,
    },
  };
}
